<template>
  <div>
    <ul class="jinNang-list">
      <li
        class="list-item"
        v-for="(item, index) in list"
        :key="index"
        @click="goto(`/jinNang/${item.jinNangId}`)"
      >
        <div v-if="sortType === 0" class="item-left">
          <div class="rate-title">总收益</div>
          <div
            class="rate-value"
            :class="[getSymbol(item.glYield) > 0 ? 'c1' : 'c3']"
          >
            {{ item.glYield }}
          </div>
        </div>
        <div v-else-if="sortType === 2" class="item-left">
          <div class="rate-title">周收益</div>
          <div
            class="rate-value"
            :class="[getSymbol(item.weekYield) > 0 ? 'c1' : 'c3']"
          >
            {{ item.weekYield }}
          </div>
        </div>
        <div v-else class="item-left">
          <div class="rate-title">月收益</div>
          <div
            class="rate-value"
            :class="[getSymbol(item.monthYield) > 0 ? 'c1' : 'c3']"
          >
            {{ item.monthYield }}
          </div>
        </div>
        <div class="item-line"></div>
        <div class="item-right">
          <div class="title">
            {{ item.title }}
            <div class="jinnang-tags">
              <el-tag
                v-for="(item, index) in item.tags.length > 1
                  ? item.tags.slice(0, 2)
                  : item.tags"
                :key="index"
                class="jinnang-tag-li"
              >
                {{ item.text }}
              </el-tag>
            </div>
          </div>
          <div class="subtitle">
            <span>胜率:{{ item.selwinidx }}</span> |
            <span>最大回撤率:{{ item.maxdrawidx }}</span>
          </div>
          <div class="sub-item" v-if="showAuthor">
            <span class="name">{{ item.authorName }}</span>
            <span>{{ item.authorTitle }} | {{ item.authorCompany }}</span>
          </div>
          <div class="sub-item">
            <span>剩余{{ item.leftServiceNum }}份</span>
          </div>
        </div>
        <div class="sale">
          <div class="price">¥{{ item.price }}/月</div>
          <div class="buybtn">购买</div>
        </div>
      </li>
      <li v-show="!end" class="more" @click="loadMore">点击查看更多</li>
    </ul>
    <div v-if="!list || list.length == 0" class="notfound">
      <div class="not-found-tip">没有找到对应的锦囊</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JinNangList',
  props: {
    list: {
      type: Array,
      required: true
    },
    end: {
      type: Boolean,
      default: true
    },
    showAuthor: {
      type: Boolean,
      default: true
    },
    sortType: {
      // 0.总收益 2.周收益 3.月收益
      type: Number,
      default: 1
    }
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
    goto(router) {
      console.log(router)
      this.$router.push(router)
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    }
  }
}
</script>

<style lang="scss" scoped>
.jinnang-tags {
  display: inline;
  margin-left: 20px;
}
.jinnang-tag-li {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  border-radius: 2px;
  border: none;
  color: #046bcc;
}
.list-item {
  display: flex;
  align-items: center;
  height: 190px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  &:hover {
    background-color: #fafafa;
  }
  position: relative;
}

.item-left {
  flex-direction: column;
  justify-content: center;
  display: flex;
  flex: none;
  flex-basis: 160px;
}

.item-line {
  width: 1px;
  height: 126px;
  background-color: #ebebeb;
}

.item-right {
  flex: auto;
  display: flex;
  justify-content: left;
  flex-direction: column;
  height: 190px;
}

.rate-title {
  margin-bottom: 11px;
  font-size: 20px;
  letter-spacing: 1px;
  color: #262626;
  text-align: center;
}

.rate-value {
  font-size: 24px;
  letter-spacing: 1px;
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #262626;
  transition: color 0.3s;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #046bcc;
  }
  margin: 30px 0 20px 30px;
}

.subtitle {
  margin-left: 30px;
  margin-bottom: 15px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #858585;
}

.sub-item {
  margin-left: 30px;
  margin-bottom: 15px;
  font-size: 14px;
  letter-spacing: 1px;
  color: #858585;
}

.name {
  margin-right: 20px;
}

.tag {
  display: flex;
  position: absolute;
  top: 31px;
  right: 0;
}

.tag-item {
  height: 22px;
  background-color: #f0f0f0;
  border-radius: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  margin-left: 20px;
  padding: 0 15px;
  color: #858585;
}

.sale {
  display: flex;
  position: absolute;
  bottom: 30px;
  right: 0;
}

.price {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #e64c2e;
}

.buybtn {
  height: 30px;
  border-radius: 2px;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  margin-left: 20px;
  padding: 0px 28px;
  background-color: #e64c2e;
  color: #ffffff;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}

.notfound {
  background: no-repeat center url('~@/assets/images/icons/not-found.png');
  height: 400px;
  text-align: center;
  font-size: 14px;
  color: #858585;
  display: flex;
  flex-direction: column;
}
.not-found-tip {
  align-items: center;
  flex-basis: 30px;
  margin-top: 250px;
}
</style>
